<div class="page-header">
    <div class="header-row">
        <div></div><!-- spacer -->
        <!-- Actions -->
        <div class="page-actions">
            <button class="btn btn-primary" (click)="addAddress()">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2"
                    stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M12 4.5v15m7.5-7.5h-15" />
                </svg>
                Add Address
            </button>
        </div>
    </div>
</div>
<div class="address-list-container">

    <!-- FILTERS SECTION -->
    <div class="filters-section">
        <div class="filters-row">
            <!-- Filter Chips -->
            <div *ngFor="let chip of filterChips" class="filter-chip" [class.active]="chip.active"
                (click)="onFilterClick(chip)">
                {{ chip.label }}
                <span class="count">{{ chip.count }}</span>
            </div>

            <!-- Search Box (Right Side) -->
            <div class="search-box">
                <svg xmlns="http://www.w3.org/2000/svg" class="search-icon" fill="none" viewBox="0 0 24 24"
                    stroke-width="2" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round"
                        d="M21 21l-5.197-5.197m0 0A7.5 7.5 0 105.196 5.196a7.5 7.5 0 0010.607 10.607z" />
                </svg>
                <input type="text" class="search-input" placeholder="Search addresses..." [(ngModel)]="searchQuery"
                    (input)="onSearch()">
                <svg *ngIf="cross" (click)="clearText()" class="cross-icon" width="16" height="16"
                    xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2"
                    stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
                </svg>
            </div>
        </div>
    </div>

    <!-- TABLE SECTION -->
    <div class="table-section" #addresstableContainer>
        <div class="table-wrapper">
            <table class="address-table">
                <thead>
                    <tr>
                        <th>#</th>
                        <th>Address</th>
                        <th>Latitude</th>
                        <th>Longitude</th>
                        <th>Actions</th>
                    </tr>
                </thead>
                <tbody>
                    <!-- Skeleton Rows -->
                    <ng-container *ngIf="isLoading">
                        <tr class="skeleton-row" *ngFor="let i of [1,2,3,4,5,6,7,8,9,10]">
                            <td><div class="skeleton-block skeleton-sno"></div></td>
                            <td><div class="skeleton-block skeleton-text-left"></div></td>
                            <td><div class="skeleton-block skeleton-text"></div></td>
                            <td><div class="skeleton-block skeleton-text"></div></td>
                            <td>
                                <div class="skeleton-actions">
                                    <div class="skeleton-btn"></div>
                                    <div class="skeleton-btn"></div>
                                    <div class="skeleton-btn"></div>
                                </div>
                            </td>
                        </tr>
                    </ng-container>

                    <!-- Actual Data Rows -->
                    <ng-container *ngIf="!isLoading">
                        <tr *ngFor="let item of addressData" [class.address-red]="+item.latitude === 1 && +item.longitude === 1">
                            <!-- Row Number -->
                            <td>{{ item.sNo }}</td>

                            <!-- Address -->
                            <td>{{ item.address }}</td>

                            <!-- Latitude -->
                            <td>
                                <span class="coordinate">{{ item.latitude | number : '1.6-6' }}</span>
                            </td>

                            <!-- Longitude -->
                            <td>
                                <span class="coordinate">{{ item.longitude | number : '1.6-6' }}</span>
                            </td>

                            <!-- Actions -->
                            <td>
                                <div class="actions-cell">
                                    <!-- View on Map -->
                                    <button class="action-btn view-btn" title="View on Map" (click)="viewOnMap(item)">
                                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                                            stroke-width="2" stroke="currentColor">
                                            <path stroke-linecap="round" stroke-linejoin="round"
                                                d="M15 10.5a3 3 0 11-6 0 3 3 0 016 0z" />
                                            <path stroke-linecap="round" stroke-linejoin="round"
                                                d="M19.5 10.5c0 7.142-7.5 11.25-7.5 11.25S4.5 17.642 4.5 10.5a7.5 7.5 0 1115 0z" />
                                        </svg>
                                    </button>

                                    <!-- Edit -->
                                    <button class="action-btn edit-btn" title="Edit" (click)="editAddress(item)">
                                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                                            stroke-width="2" stroke="currentColor">
                                            <path stroke-linecap="round" stroke-linejoin="round"
                                                d="M16.862 4.487l1.687-1.688a1.875 1.875 0 112.652 2.652L10.582 16.07a4.5 4.5 0 01-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 011.13-1.897l8.932-8.931zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0115.75 21H5.25A2.25 2.25 0 013 18.75V8.25A2.25 2.25 0 015.25 6H10" />
                                        </svg>
                                    </button>

                                    <!-- Delete -->
                                    <button class="action-btn delete-btn" title="Delete" (click)="deleteOrder(item.id)">
                                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                                            stroke-width="2" stroke="currentColor">
                                            <path stroke-linecap="round" stroke-linejoin="round"
                                                d="M14.74 9l-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 01-2.244 2.077H8.084a2.25 2.25 0 01-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 00-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 013.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 00-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 00-7.5 0" />
                                        </svg>
                                    </button>
                                </div>
                            </td>
                        </tr>

                        <!-- No Results -->
                        <tr *ngIf="addressData?.length === 0">
                        <td colspan="5" style="text-align: center; padding: 40px; color: #9ca3af;">
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                                stroke="currentColor"
                                style="width: 48px; height: 48px; margin: 0 auto 16px; opacity: 0.5;">
                                <path stroke-linecap="round" stroke-linejoin="round"
                                    d="M15 10.5a3 3 0 11-6 0 3 3 0 016 0z" />
                                <path stroke-linecap="round" stroke-linejoin="round"
                                    d="M19.5 10.5c0 7.142-7.5 11.25-7.5 11.25S4.5 17.642 4.5 10.5a7.5 7.5 0 1115 0z" />
                            </svg>
                            <div style="font-size: 16px; font-weight: 500; margin-bottom: 4px;">No addresses found</div>
                            <div style="font-size: 14px;">Try adjusting your search or filters</div>
                        </td>
                    </tr>
                </ng-container>
                </tbody>
            </table>
        </div>
    </div>

    <!-- PAGINATION FOOTER -->
    <div class="pagination-footer">
        <!-- <div class="pagination-info">
            {{ getPaginationInfo() }}
        </div> -->

        <div class="pagination-controls">
            <button class="nav-arrow" [disabled]="currentPage === 1" (click)="goToPreviousPage()">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2"
                    stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 19.5L8.25 12l7.5-7.5" />
                </svg>
            </button>

            <div class="pagination-info">
                <!-- Page {{ currentPage }} of {{ totalPages }} -->
                {{ getPaginationInfo() }}
            </div>

            <button class="nav-arrow" [disabled]="currentPage === totalPages" (click)="goToNextPage()">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2"
                    stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M8.25 4.5l7.5 7.5-7.5 7.5" />
                </svg>
            </button>
        </div>
    </div>

</div>